import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.customerCancelFoodPage.setFetching(isFetching)

const cancelOrder = (orderId) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.orderCancel + `/${orderId}`, {})
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}

const fetch = (orderId) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  
  return request.get(prefix.orderCancelPartial + `/${orderId}`)
    .then(({ data }) => data)
    .then((order) => {
      reducers.marketplace.customerCancelFoodPage.setOrder(order)

      return order
    })
}

const fetchOrderTotal = ({ orderId, positions }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.orderCancelPartial + `/${orderId}/total`, positions)
    .then(({ data }) => data)
    .then(({ total }) => reducers.marketplace.customerCancelFoodPage.setTotal(total))
    .catch((error) => console.log(error))
}

const clearOrderTotal = () => (
  reducers.marketplace.customerCancelFoodPage.setTotal(0)
)

const cancelOrderPartial = ({ orderId, positions }) => {
  const {
    marketplace: {
      layersNavigation: {
        category: selectedCategory, area: selectedArea,
      },
    },
  } = getState()
  
  const isRpc = selectedCategory === 'rpc'
  const prefix = isRpc ? constants.rpc : constants.edu
  return request.post(prefix.orderCancelPartial + `/${orderId}`, positions)
    .then(({ data }) => data)
    .catch((error) => console.log(error))
}


export default {
  setFetching,
  cancelOrder,
  clearOrderTotal,
  fetch,
  fetchOrderTotal,
  cancelOrderPartial,
}
